export const defaultLightConfiguration = {
    enabled: true,
    castShadow: true,
    intensity: 4,
    color: 0xffffff,
    elevation: 1.33,
    azimuth: 0.75,
    radius: 0,
    indirectLightIntensity: 1,
};
